<ng-container *ngIf="entity">
  <div class="table vert-0100"
       id="about">
    <div class="tr tr--noGutter tile__heading pt-0 pb-0">{{title || 'Name'}}
      <ng-container *ngIf="showTaskDoneMark">
        <span class="color--gray ml-0050">
          &bull;
          <span class="color--green">
            <span class="d-none d-inline--md uppercase ml-0025">Done</span>
            <i class="far fa-check ml-0025"></i>
          </span>
        </span>
      </ng-container>
      <button mat-button
              disableRipple
              class="addNew ml-auto mat-button--no-focus-overlay"
              type="button"
              aria-label="Edit Name"
              (click)="openEditNameDialog()">
        <i class="far fa-pencil addNew__icon"></i>
        EDIT
      </button>
    </div>
    <div class="tr tr--noGutter pt-0025">
      <div class="tc tc--80">
        <div class="row row--left fb--baseline recap w-100">
          <div class="recap__label">Name</div>
          <div class="recap__value"
               data-test-id="nameRecap">
            {{entity | fullName}}
          </div>

          <ng-container *ngIf="entity?.entityType?.pronounsEnabled">
            <div class="recap__label">Pronouns</div>
            <div class="recap__value">{{entity.pronouns}}</div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-container>
